export default __webpack_public_path__ + "static/media/bin_disable.049cffad.svg";